/**=========================================================
 * Module: wizard.js
 * Wizard Controller
 =========================================================*/

App.controller('WizardController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', 'DataService',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, D) {
    "use strict";
     
    $scope.wizardStep = function(index){
        $scope.form.activeStep = index;
        $timeout(function(){$rootScope.$broadcast('$recalculateTooltipPosition');},200);
    };
      
      
  }
  ]);